"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParallelRunner = void 0;

var _circularBuffer = require("./circular-buffer");

var _asyncIteratorProxy = require("./async-iterator-proxy");

class ParallelRunner extends _asyncIteratorProxy.AsyncIteratorProxy {
  constructor(iterator, mapFn, concurrency) {
    super(iterator);
    this.buffer = new _circularBuffer.CircularBuffer(concurrency - 1);
    this.mapFn = mapFn;
  }

  next() {
    const {
      buffer,
      mapFn
    } = this;
    const done = this.__done;
    const promise = super.next().then(async item => item.done ? item : {
      value: await mapFn(item.value),
      done: false
    });
    const displacedPromise = buffer.push(promise);

    if (displacedPromise) {
      return displacedPromise;
    } else {
      if (done) {
        return promise;
      } else {
        return this.next();
      }
    }
  }

}

exports.ParallelRunner = ParallelRunner;